import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepCreditCardDebt: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>What’s your estimated current credit card debt?</StepTitle>
    <ApplicationField product={Product.Loan} field={Fields.CreditCardDebt} onEnter={props.onEnter} />
  </Wrapper>
)

export default StepbystepApplicationStepCreditCardDebt
